import { render, staticRenderFns } from "./Complaints .vue?vue&type=template&id=1c67f0de&scoped=true&"
import script from "./Complaints .vue?vue&type=script&lang=js&"
export * from "./Complaints .vue?vue&type=script&lang=js&"
import style0 from "./Complaints .vue?vue&type=style&index=0&id=1c67f0de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c67f0de",
  null
  
)

export default component.exports